module.exports = __webpack_public_path__ + "assets/img/05.canal-deploy.138b17a3.png";